<form #form="ngForm">
  @if (uiConfiguration.lienDetailsConfiguration?.showConsumerGoods ||
    uiConfiguration.lienDetailsConfiguration?.showInventory ||
    uiConfiguration.lienDetailsConfiguration?.showEquipment ||
    uiConfiguration.lienDetailsConfiguration?.showAccounts ||
    uiConfiguration.lienDetailsConfiguration?.showOther ||
    uiConfiguration.lienDetailsConfiguration?.showMVIncluded) {
    <app-on-collateral
      [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [order]="order" [errors$]="observableErrors$"
    (ontarioCollateralFormValueChangedEvent)="handleCollateralOntarioCollateralFormValueChangedEvent($event)"></app-on-collateral>
  }

  @if (uiConfiguration.collateralConfiguration?.hasGeneralCollateral) {
    <app-general-collateral
      [uiConfiguration]="uiConfiguration!.collateralConfiguration!.generalCollateralConfiguration!" [order]="order!"
      [errors$]="observableErrors$"
    (generalCollateralFormValueChangedEvent)="handleGeneralCollateralFormValueChangedEvent($event)"></app-general-collateral>
  }

  @if (uiConfiguration.collateralConfiguration?.hasAssets) {
    <app-assets
      [uiConfiguration]="$safeNavigationMigration(uiConfiguration.collateralConfiguration?.assetConfiguration)!" [errors$]="observableErrors$"
    (assetFormValueChangedEvent)="handleAssetFormValueChangedEvent($event)"></app-assets>
  }
</form>